import { render, staticRenderFns } from "./HisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=template&id=76d8a5e5&scoped=true&"
import script from "./HisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./HisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./HisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=style&index=0&id=76d8a5e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d8a5e5",
  null
  
)

export default component.exports